let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3Nc7d")).then(() => parcelRequire('nfKKY'));